import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp, TrendingDown, Users, Target, DollarSign, Repeat, UserMinus } from 'lucide-react';
import { KPICard as KPICardType } from '@/data/mockData';

interface KPICardProps {
  data: KPICardType;
}

const iconMap = {
  TrendingUp,
  TrendingDown,
  Users,
  Target,
  DollarSign,
  Repeat,
  UserMinus
};

export const KPICard: React.FC<KPICardProps> = ({ data }) => {
  const Icon = iconMap[data.icon as keyof typeof iconMap] || TrendingUp;
  const isPositive = data.changeType === 'increase';
  
  return (
    <Card className="relative overflow-hidden transition-smooth hover:shadow-elegant animate-fade-in-up">
      <div className={`absolute inset-0 opacity-5 ${isPositive ? 'gradient-success' : 'gradient-warning'}`} />
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {data.title}
        </CardTitle>
        <Icon className={`h-4 w-4 ${isPositive ? 'text-green-600' : 'text-orange-600'}`} />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{data.value}</div>
        <div className="flex items-center space-x-2 mt-2">
          <Badge 
            variant={isPositive ? "default" : "destructive"}
            className={`text-xs ${isPositive ? 'bg-green-100 text-green-800 hover:bg-green-100' : 'bg-red-100 text-red-800 hover:bg-red-100'}`}
          >
            {isPositive ? '+' : ''}{data.change}%
          </Badge>
          <span className="text-xs text-muted-foreground">vs mês anterior</span>
        </div>
        <p className="text-xs text-muted-foreground mt-2">
          {data.description}
        </p>
      </CardContent>
    </Card>
  );
};